/*
 * @Author: vicshang
 * @Date: 2020-08-17 15:33:21
 * @Last Modified by: vicshang
 * @Last Modified time: 2020-09-14 09:24:29
 */

<template>
  <Card class="clearfix">
    <p slot="title">{{title}}</p>
    <Form label-position="left">
      <Row :gutter="16" v-for="(row, index) in fields" :key="index" >
        <Col :xs="24" :sm="12" :md="item.span" v-for="(item, indexKey) in row" :key="indexKey">
          <FormItem :label="item.label + '：'" v-if="item.type=='image'">
            <img-upload v-model="item.value" :keyVal="item.imgKey" :edit="false" />
          </FormItem>
          <FormItem :label="item.label + '：'" v-else>
            <span>{{item.value}}{{item.suffix ? item.suffix: ''}}</span>
          </FormItem>
        </Col>
      </Row>
    </Form>
  </Card>
</template>
<script>
import ImgUpload from '../img-upload';
export default {
  name: 'CustomCard',
  components: {
    ImgUpload
  },
  props: {
    title: { // Card 的标题
      type: String,
      default: ''
    },
    dataArr: { // 字段数据
      type: Array,
      default: []
    },
    defaultSpan: { // 默认每个字段占多少格，基于bootsrtap栅格（24）
      type: Number,
      default: 8
    }
  },
  data () {
    return {
      fields: []
    };
  },
  mounted () {
    this.initFields(); // 初始化字段
  },
  watch: { // 监听字段
    dataArr () {
      this.initFields();
    }
  },
  methods: {
    initFields () { // 初始化字段方法
      const { dataArr, defaultSpan } = this;
      const spanNum = 24;
      if (dataArr.length) {
        const fields = []; // 多维数组
        let row = [];
        let span = 0;
        for (let i = 0; i < dataArr.length; i++) {
          dataArr[i].type = dataArr[i] ? (dataArr[i].type || 'text') : 'text'; // 兼容text和图片展示
          const itemSpan = dataArr[i].type == 'image' ? spanNum : (dataArr[i] ? (dataArr[i].span || defaultSpan) : defaultSpan); // 单个字段所占栅格数
          dataArr[i].span = itemSpan; // 补全span属性
          dataArr[i].isShow = dataArr[i] ? (dataArr[i].isShow != undefined ? dataArr[i].isShow : true) : true; // 补全isShow 属性
          if (dataArr[i].isShow) {
            span += itemSpan;
            row.push(dataArr[i]);
            if (span >= spanNum) {
              fields.push(row);
              span = 0;
              row = [];
            } else {
              if ((i + 1) == dataArr.length) {
                fields.push(row);
              }
            }
          }
        }
        this.fields = fields;
      }
    }
  }
};
</script>
